import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import type { VarianceGroupBy } from '@/common/api/types/dashboard/variance';

type InsightsQueryKeyParams = {
  filters?: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId?: number;
  orgId?: string;
  dateRange?: { from: string; to: string };
};

type VarianceQueryKeyParams = InsightsQueryKeyParams & {
  groupBy: VarianceGroupBy[];
};

export const insightsQueryKeys = {
  scopeSize: {
    all: () => ['insightsScopeSize'] as const,
    byFilters: ({ filters, scopeItemId, loopId, orgId }: InsightsQueryKeyParams) => [
      'insightsScopeSize',
      orgId,
      loopId,
      filters,
      scopeItemId,
    ],
  },
  trends: {
    all: () => ['insightsTrendsProgress'] as const,
    progress: ({ filters, scopeItemId, loopId, orgId, dateRange }: InsightsQueryKeyParams) => [
      'insightsTrendsProgress',
      orgId,
      loopId,
      filters,
      scopeItemId,
      dateRange,
    ],
  },
  variance: {
    all: () => ['insightsVarianceBreakdown'] as const,
    breakdown: ({ filters, scopeItemId, loopId, orgId, groupBy }: VarianceQueryKeyParams) => [
      'insightsVarianceBreakdown',
      orgId,
      loopId,
      filters,
      scopeItemId,
      groupBy,
    ],
  },
} as const;
